import { Component, Input, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Component({
  selector: 'company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  standalone: false,
})
export class CompanyInfoComponent implements OnInit {
  /** Description of the company (Name) */
  @Input() companyDescription: string;
  /** Enabled services for the company like Shop, Order Tracking, etc */
  @Input() companyEnabledServices: string;
  /** Flag indicating if company data exists */
  @Input() companyDataExists: boolean;

  constructor() {}

  ngOnInit(): void {}
}
